import { render, staticRenderFns } from "./AllRatingsAdmin.vue?vue&type=template&id=90020e68&scoped=true"
import script from "./AllRatingsAdmin.vue?vue&type=script&lang=js"
export * from "./AllRatingsAdmin.vue?vue&type=script&lang=js"
import style0 from "./AllRatingsAdmin.vue?vue&type=style&index=0&id=90020e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90020e68",
  null
  
)

export default component.exports